import { ITagResult } from '../../../httpClient/serverApi/types/IResponse';
import {IAnalyticsExtWorkbookId} from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { TagRequest } from '../../../ts/ServerApi/requests/TagRequest';

export type IRemoveAnalyticsExtConnectionForWorkbookResult = ITagResult;

export class RemoveAnalyticsExtConnectionForWorkbookRequest extends TagRequest<IAnalyticsExtWorkbookId, IRemoveAnalyticsExtConnectionForWorkbookResult> {
  constructor(WorkbookId: IAnalyticsExtWorkbookId) {
    super('analyticsextensions', 'deleteConnectionFromWorkbook', WorkbookId);
  }
}
